export default __webpack_public_path__ + "static/media/Red0004.345d0378.png";